const Style = {

  toolbar: 'flex items-center justify-between mb-2',
  toolbarText: 'text-sm text-slate-500',
  toolbarLink: 'text-sm text-blue-500 hover:underline',

  // the wrapper carries a measured inline height – the frame fills it and
  // scrolls internally, so the app shell never scrolls sideways
  frameWrap: 'w-full overflow-hidden rounded',
  connecting: 'bg-slate-100',
  frame: 'h-full w-full block border-0',

  noticeLink: 'text-sm text-blue-500 hover:underline',

}

export default Style;
